import { STATS } from "../../utils/constants";
import StatsBandTemplate from "./StatsBandTemplate";

export default function StatsBand() {
  return <StatsBandTemplate stats={STATS} />;
}
